import type {
  CreateWantedProfileBody,
  UpdateWantedProfileBody,
  WantedProfileListParams,
} from "@asap/shared/schemas/wanted-profile";
import { useApi } from "~/composables/useApi";

export const useWantedProfileApi = () => {
  const { invoke } = useApi();

  const list = async (query: WantedProfileListParams) => {
    const answer = await invoke({ path: "wanted-profiles", method: "GET", query });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const listJobCodesOfAgency = async (agencyId: string) => {
    const answer = await invoke({
      path: "wanted-profiles/job-codes",
      method: "GET",
      query: { agency_id: agencyId },
    });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data.job_codes;
  };

  const create = async (body: CreateWantedProfileBody) => {
    const answer = await invoke({ path: "wanted-profiles", method: "POST", body });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const update = async (id: string, body: UpdateWantedProfileBody) => {
    const answer = await invoke({ path: "wanted-profiles/:id", method: "PATCH", params: { id }, body });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const listJobMatrixTags = async () => {
    const answer = await invoke({ path: "job-matrix/tags", method: "GET", query: { axis: "job" } });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data.tags;
  };

  return { list, listJobCodesOfAgency, create, update, listJobMatrixTags };
};
